// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveNotice{box-sizing:border-box;color:#000;background-color:#d8deea;border:1px solid #acacac;border-radius:4px;padding:8px 12px;opacity:0;transition:opacity .3s ease-in-out}.SaveNotice.visible{opacity:1}.darkmode .SaveNotice{color:#000}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
